<template>
  <div>
    <h1>TODOS</h1>
    <p>You are logged in as {{ auth.username }} at {{ auth.server }}.</p>
  </div>
  <div v-if="isPending" class="update">Loading...</div>
  <div v-else-if="isError">An error has occurred: {{ error }}</div>
  <div v-else-if="data && data.data">
    <v-list lines="two">
      <template v-for="b in data.data.data" :key="b.id">
        <v-list-item
          v-if="b.owner && b.owner.login && b.name && b.has_issues"
          :subtitle="b.description || ''"
          :title="b.full_name || ''"
          @click="go(b)"
        />
      </template>
    </v-list>
    <div v-if="isFetching" class="update">Background Updating...</div>
  </div>
</template>
<script setup lang="ts">
import type { AuthorizationToken } from "../authenticationTokens";
import { type Repository, useRepoSearch } from "../gen/forgejo-vue";
import { useRouter } from "vue-router";

const props = defineProps<{
  auth: AuthorizationToken;
}>();

const router = useRouter();

const { isPending, isError, isFetching, data, error } = useRepoSearch({
  uid: props.auth.uid,
  priority_owner_id: props.auth.uid,
  exclusive: true,
  mode: "source",
  archived: false,
});

async function go(repo: Repository) {
  if (repo.owner?.login && repo.name) {
    await router.push({
      name: "repo",
      params: { repo: repo.name },
    });
  }
  console.log(repo);
}
</script>
